import { Card, CardHeader, CardBody, Row, Col, Input } from "reactstrap";

const FilterOrderBySection = ({
  field,
  direction,
  handleOrderByChange,
  staticFields,
}) => {
  return (
    <Card className="border shadow bg-white">
      <CardHeader className="p-2">
        <h5 className="text-uppercase mb-0 text-medium">Order By</h5>
      </CardHeader>
      <CardBody className="p-2">
        <Row>
          <Col sm={12} md={6}>
            <Input
              type="select"
              value={field}
              bsSize="sm"
              onChange={(e) => handleOrderByChange("Field", e.target.value)}
            >
              <option value="" disabled>
                -- Select Field --
              </option>
              {staticFields.map((field) => (
                <option key={field.APIName} value={field.APIName}>
                  {field.Name}
                </option>
              ))}
            </Input>
          </Col>
          <Col sm={12} md={6}>
            <Input
              type="select"
              value={direction}
              bsSize="sm"
              onChange={(e) => handleOrderByChange("Direction", e.target.value)}
            >
              <option value="" disabled>
                -- Select Direction --
              </option>
              <option value={"ASC"}>Ascending</option>
              <option value={"DESC"}>Descending</option>
            </Input>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default FilterOrderBySection;
